<template>
  <v-toolbar
    color="blue darken-3"
    dark
    app
    :clipped-left="$vuetify.breakpoint.mdAndUp"
    fixed>
    <v-layout style="width: 100%;" align-center justify-space-between>
      <v-flex xs1><v-toolbar-side-icon @click.stop="toogleDrawer"></v-toolbar-side-icon></v-flex>
      <v-flex><div class="hidden-sm-and-down pointer text-xs-center headline" v-on:click="goToRoot()">Mecanica Online</div></v-flex>
    </v-layout>
    <v-spacer></v-spacer>
    <v-btn icon v-on:click="goToRoot()">
      <v-icon>apps</v-icon>
    </v-btn>
    <v-btn icon>
      <v-icon>notifications</v-icon>
    </v-btn>
    <v-btn icon large>
      <v-avatar size="32px" tile>
        <img
          src="/static/logo-240x240.jpg"
          alt="Vuetify">
      </v-avatar>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  name: "Navigation",
  components: {},
  props: {
    drawer: Boolean
  },
  methods: {
    toogleDrawer() {
      this.$emit("toogle-drawer");
    },
    goToRoot() {
      this.$router.push({ path: '/' });
    }
  },
  data() {
    return {};
  }
};
</script>

<style>
  .pointer {
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/mecanica/Toolbar.vue